import React from "react"
import {
  MDBJumbotron,
  MDBBtn,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCardTitle,
  MDBIcon,
  MDBCard,
  MDBCardBody,
  MDBCardText,
} from "mdbreact"
import RegisterForm from "./registerForm"

const Jumbotron = ({ background }) => {
  return (
    <MDBJumbotron
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
      }}
      className="container-fluid"
    >
      <MDBContainer>
        <MDBRow className="py-md-5 my-md-5">
          <MDBCol size="12" md="7">
            <h1 className="display-4 font-weight-bold pt-3 my-5 font-bold white-text text-center text-md-left">
              Simply Smarter H1
            </h1>
            <p className="mb-5 white-text text-center text-md-left lead">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat
              fugiat, laboriosam, voluptatem.
            </p>
            <MDBRow>
              <MDBCol className="text-center text-md-left">
                <MDBBtn color="orange" className="mb-5" href="#">
                  <MDBIcon icon="info" className="mr-2" />
                  Learn More
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          </MDBCol>

          <MDBCol size="12" md="5">
            <MDBCard>
              <MDBCardTitle
                style={{ backgroundColor: "#ccc" }}
                className="py-3 text-center"
              >
                Get More Information
              </MDBCardTitle>
              <MDBCardBody>
                <MDBCardText className="mb-4 text-center">
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                </MDBCardText>
                <RegisterForm />
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </MDBJumbotron>
  )
}

export default Jumbotron
